export {default} from './GlobalLayout';



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/index.ts